<template>
  <page-header title="Инвентарь" icon="bi-tools"/>
  <std-table
      :format="[
        ['name','Имя ресурса'],
        ['kind','Вид ресурса'],
        ['description','Описание'],
      ]"
      url="/inventory"
      resource="resource"
      button="Добавить ресурс"
  />


</template>

<script>
import PageHeader from "@/components/PageHeader";
import StdTable from "@/components/StdTable";

export default {
  components: {StdTable, PageHeader},
}
</script>
